import { Maybe } from "@shared/graphql.types";

export const requireFromMaybe = <T>(
  value: Maybe<T> | undefined,
  fieldName: string
): T => {
  if (value == null) {
    throw new Error(`Missing required field: ${fieldName}`);
  }
  return value;
};
